import * as i0 from '@angular/core';
import { Injectable, ViewContainerRef, Component, Input, ViewChild, NgModule } from '@angular/core';
import * as i2 from '@upr-web-primer/tcm-rtf-html-process';
import * as i1 from '@upr-web-primer/pipes';
import { PascalCasePipe } from '@upr-web-primer/pipes';

class DynamicComponentService {
    constructor(componentFactoryResolver, pascalCasePipe) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.pascalCasePipe = pascalCasePipe;
    }
    createComponent(component, viewRef, componentList) {
        if (component.selector === 'TabBreakComponent' ||
            component.selector === 'PageReferenceComponent') {
            return;
        }
        component.selector = component.selector.replace('InternalUse', '');
        if (!componentList) {
            console.error(`missing Angular Component list to create ${component.selector}`);
            return false;
        }
        if (!viewRef) {
            console.error(`No Angular view container for ${component.selector}`);
            return false;
        }
        const dynamicComponent = componentList[component.selector];
        if (!dynamicComponent) {
            console.error(`missing Angular ${component.selector}`);
            return false;
        }
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(dynamicComponent);
        if (!componentFactory) {
            console.error(`failed to resolve component factory: ${component.selector}`);
            return false;
        }
        const componentRef = viewRef.createComponent(componentFactory);
        if (!componentRef) {
            console.error(`failed to create component: ${component.selector}`);
            return false;
        }
        if (component.tile && component.defaultValues) {
            componentRef.instance.tile = component.tile;
            componentRef.instance.defaultValues = component.defaultValues;
        }
        componentRef.instance.data = component.data;
        return componentRef;
    }
    getComponentName(selector) {
        return (this.pascalCasePipe.transform(selector.replace(/ - Angular/g, '').replace('/', ' ')) + 'Component');
    }
    paintExistingComponent(component, data, viewRef) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
        if (!componentFactory) {
            console.error(`failed to resolve component factory: ${component.selector}`);
            return false;
        }
        const componentRef = viewRef.createComponent(componentFactory);
        if (!componentRef) {
            console.error(`failed to create component: ${component.selector}`);
            return false;
        }
        componentRef.instance.data = data;
        return componentRef;
    }
}
DynamicComponentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DynamicComponentService, deps: [{ token: i0.ComponentFactoryResolver }, { token: i1.PascalCasePipe }], target: i0.ɵɵFactoryTarget.Injectable });
DynamicComponentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DynamicComponentService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DynamicComponentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i0.ComponentFactoryResolver }, { type: i1.PascalCasePipe }]; } });

class DynamicComponentComponent {
    constructor(dynamicComponents, tcmRtfProcessor) {
        this.dynamicComponents = dynamicComponents;
        this.tcmRtfProcessor = tcmRtfProcessor;
    }
    ngOnInit() {
        if (this.existingComponent) {
            this.dynamicComponents.paintExistingComponent(this.existingComponent, this.data, this.viewContainerRef);
            return;
        }
        if (!this.selector || !this.data) {
            return;
        }
        this.component = {
            selector: this.dynamicComponents.getComponentName(this.selector),
            data: this.tcmRtfProcessor.processTcmData(this.data),
            tile: this.tile,
            defaultValues: this.defaultValues
        };
        this.dynamicComponents.createComponent(this.component, this.viewContainerRef, this.list);
    }
}
DynamicComponentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DynamicComponentComponent, deps: [{ token: DynamicComponentService }, { token: i2.TcmRftHtmlProcessService }], target: i0.ɵɵFactoryTarget.Component });
DynamicComponentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: DynamicComponentComponent, selector: "upr-dynamic-component", inputs: { existingComponent: "existingComponent", selector: "selector", data: "data", list: "list", tile: "tile", defaultValues: "defaultValues" }, viewQueries: [{ propertyName: "viewContainerRef", first: true, predicate: ["container"], descendants: true, read: ViewContainerRef, static: true }], ngImport: i0, template: "<ng-container #container></ng-container>\r\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DynamicComponentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'upr-dynamic-component', template: "<ng-container #container></ng-container>\r\n" }]
        }], ctorParameters: function () { return [{ type: DynamicComponentService }, { type: i2.TcmRftHtmlProcessService }]; }, propDecorators: { existingComponent: [{
                type: Input
            }], selector: [{
                type: Input
            }], data: [{
                type: Input
            }], list: [{
                type: Input
            }], tile: [{
                type: Input
            }], defaultValues: [{
                type: Input
            }], viewContainerRef: [{
                type: ViewChild,
                args: ['container', {
                        read: ViewContainerRef,
                        static: true
                    }]
            }] } });

class DynamicComponentModule {
}
DynamicComponentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DynamicComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DynamicComponentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DynamicComponentModule, declarations: [DynamicComponentComponent], exports: [DynamicComponentComponent] });
DynamicComponentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DynamicComponentModule, providers: [PascalCasePipe], imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DynamicComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DynamicComponentComponent],
                    imports: [],
                    providers: [PascalCasePipe],
                    exports: [DynamicComponentComponent]
                }]
        }] });

export { DynamicComponentComponent, DynamicComponentModule, DynamicComponentService };
